/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.organizationModule')
  .controller('OrganizationsController', ['allOrganizations', '$modal', '$rootScope', 'Restangular', 'BulbBusyService', OrganizationsController]);

function OrganizationsController(allOrganizations, $modal, $rootScope, Restangular, BulbBusyService) {
  const that = this;

  this.currentTab = 'all';
  this.searchQuery = '';

  this.allOrganizations = allOrganizations.plain().sort((a, b) => a.displayName.toUpperCase().localeCompare(b.displayName.toUpperCase()));

  this.gmetrixOrganizations = this.allOrganizations.filter((org) => org.isGMetrixOrg);

  this.filteredOrganizations = function () {
    const query = that.searchQuery.toLowerCase();

    if (that.currentTab === 'all') {
      return that.allOrganizations.filter((org) => org.displayName.toLowerCase().includes(query));
    } if (that.currentTab === 'gmetrix') {
      return that.gmetrixOrganizations.filter((org) => org.displayName.toLowerCase().includes(query));
    }
  };

  this.createOrganization = function () {
    var modalInstance = $modal.open({
      templateUrl: 'ajs/organization/create-organization.html',
      controller() {
        const self = this;
        self.submitOrg = function () {
          modalInstance.close(self);
        };
        self.handleSettingFormGroupType = function (event) {
          this.groupType = event.selectedOption;
        };
      },
      controllerAs: 'createOrgFormCtrl',
      scope: this.scope,
      backdrop: true,
      windowClass: 'bulb-media-transient',
    });
    modalInstance.result.then((scope) => {
      const body = {
        displayName: scope.displayName,
      };
      Restangular.all('organizations').post(body).then((createdOrganization) => {
        that.allOrganizations.push(createdOrganization);
      });
    });
  };

  /**
   * Toggle the org suspended status.
   */
  this.toggleOrgSuspended = (organization) => {
    const organizationDTO = {
      suspended: organization.suspended,
    };

    BulbBusyService.showBusyDuring(
      Restangular.one('organizations', organization.id).patch(organizationDTO)
        .then(() => {
          // Success: Broadcast the change
          $rootScope.$broadcast('$orgRestrictionsChanged');
        })
        .catch(() => {
          // Failure: Revert the checkbox to its previous state
          organization.suspended = !organization.suspended;
        }),
    );
  };
}
